import { render, staticRenderFns } from "./ModalCorrectInputNumericlal.vue?vue&type=template&id=5b1267d8&scoped=true&lang=pug&"
import script from "./ModalCorrectInputNumericlal.vue?vue&type=script&lang=ts&"
export * from "./ModalCorrectInputNumericlal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1267d8",
  null
  
)

export default component.exports